import { useState } from 'react';

import { revoke } from '../../sources';
import { authenticate, logout as userLogout } from './sources';

export const useLegacy = ({ signInOnLoad, onNoSession }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(signInOnLoad);

  const logout = async () => {
    try {
      await revoke();
      await userLogout();

      setIsAuthenticated(false);
    } catch (e) {
      throw e;
    }
  };

  const login = async (params) => {
    await authenticate(params);

    setIsAuthenticated(true);
  };

  return {
    _hasError: false,
    _name: 'legacy',
    loaded: true,
    active: false,
    login: login,
    logout: logout,
    getAccessToken: async () => undefined,
    isAuthenticated: isAuthenticated,
    onUnauthorized: () => {
      setIsAuthenticated(false);
      onNoSession();
    },
  };
};
